interface ISearchTypes {
  dynamicPackage: string;
}

export const SearchTypes: ISearchTypes = {
  dynamicPackage: "dp",
};
